import Vue from 'vue'

// SEE https://firebase.google.com/docs/reference/js/firebase.auth.Auth#error-codes

export default Vue.mixin({
  methods: {
    firebase_message(code, details) {
      if (details) {
        if (details.message.startsWith("'from' parameter is not a valid address.")) {
          return 'Please enter a valid email address';
        }
      }
      switch (code){
        // LOGIN
        case 'auth/operation-not-allowed' : return 'There is a problem with the authentication system.  It\'s us, not you.  Please contact us.';
        case 'auth/user-not-found'        : return 'We were unable to log you in.  Please check your username and password.';
        case 'auth/wrong-password'        : return 'We were unable to log you in.  Please check your username and password.';
        case 'auth/too-many-requests'     : return 'We were unable to log you in.  Please check your username and password.';
        case 'auth/user-disabled'         : return 'This account is disabled.  Please get in touch with us.'

        // REGISTRATION
        case 'auth/email-already-in-use'  : return 'This email address is already in use.'

        // FUNCTIONS
        case 'internal'                   : return 'There was an error. Please check your internet connectivity and try again.'
        case 'invalid-argument'           : return 'A field supplied isn\'t valid.'

        // DEFAULT
        default                           : return 'Unknow Error: ' + code;
      }
    }
  }
});